export const LOAD = 'LOAD';
export const HAS_LOADED = 'HAS_LOADED';
export const ADD_ERROR = 'ADD_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const CLEAR_ERRORS_BY_PATTERN = 'CLEAR_ERRORS_BY_PATTERN';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const FLUSH_NOTIFICATIONS = 'FLUSH_NOTIFICATIONS';
